import Phaser from 'phaser'
import 'regenerator-runtime'

export default class Highscore extends Phaser.Scene {

    constructor() {
        super('highscore');
    }

    preload() {
        // Lade die JSON-Daten für die Highscores
        this.load.json('highscores', './scores/read.php?game=social');
    }

    create() {
        // Rufe die Highscore-Daten aus der JSON-Datei ab
        const highscores = this.cache.json.get('highscores');
        const data = highscores.data || [];

        // Sortiere die Highscores nach den Punktzahlen in absteigender Reihenfolge
        data.sort((a, b) => b.score - a.score);
    
        // Highscore-Liste
        const playerName = sessionStorage.getItem('player'); 
        const playerScore = sessionStorage.getItem('minutes');
        
        // Zeige die Highscore-Tabelle auf dem Bildschirm an
        let y = 100;
        for (let i = 0; i < data.length; i++) {
            const record = data[i];
            const text = `${i + 1}. ${record.name}: ${record.score}`;
    
            this.add.text(100, y, text, { fontSize: '32px', fontStyle: 'bold', color: '#ffffff' });
            y += 50;
        }
    
        // Beispiel: Ein neuer Highscore wird eingereicht
        this.submitScore(playerName, playerScore);
    }
    
    submitScore(name, score) {
    // Erstelle FormData oder URLSearchParams
    const formData = new URLSearchParams({
        game: 'social',
        name,
        score: score.toString()
    });

    // fetch-Request
    fetch('https://social.dhbw-stuttgart.de/scores/update.php', {
        method: 'POST',
        body: formData
    })
    .then(async response => {
        if (!response.ok) {
            throw new Error(`Server-Antwort ${response.status}`);
        }
        // Falls deine API Text zurückgibt:
        const text = await response.text();
        console.log('Erfolgreiche Antwort vom Server:', text);
        // Oder falls JSON zurückkommt:
        // const json = await response.json();
        // console.log('Server-Response JSON:', json);
    })
    .catch(err => {
        console.error('Fehler beim Einreichen des Highscores:', err);
    });
}

}
